import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, BadgeCheck, CheckCircle } from 'lucide-react';
const HeaderGlpAdv5 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17661">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17662"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17663">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17664">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17665">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17666">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17667">
          <div className="text-left" data-id="element-17668">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17669">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17670">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17671">
        <div className="max-w-4xl mx-auto" data-id="element-17672">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17673">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-17674">
            Patient Story: "I Almost Lost My Marriage Along With The Weight" —
            Why So Many GLP-1 Users Feel Numb, Exhausted, And Empty And How To
            Stay On The Medication Without The Mental Cost
          </h1>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-17675">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-17676">
              <img src="https://cdn.magicpatterns.com/uploads/dZsfYoUn5AK95fR4SRF9oa/YCyEt6vcI9ES0sqc36Qz6.png" alt="Patient" className="w-full h-full object-cover" data-id="element-17677" />
            </div>
            <div className="flex-1" data-id="element-17678">
              <div className="flex items-center gap-2 mb-2" data-id="element-17679">
                <span className="text-base font-medium text-gray-900" data-id="element-17680">
                  Written By Martha R.
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-17681" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17682">
                Verified GLP-1 User • 11 Months on Treatment
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-17683">
                <div className="flex items-center gap-1" data-id="element-17684">
                  <ClockIcon className="h-4 w-4" data-id="element-17685" />
                  <span data-id="element-17686">14 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-17687">
                  <EyeIcon className="h-4 w-4" data-id="element-17688" />
                  <span data-id="element-17689">31,542 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-17690">
            The Breakthrough Discovery From Uppsala University Research That Is
            Allowing Over 36,700 People To Continue Losing Weight With NO
            Depression, Anxiety, Numbness, Disconnected Feeling, Loss Of
            Motivation, Insomnia, Nightmares or Sense Of Dread
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17691">
            <div className="mb-1 flex items-center" data-id="element-17692">
              <span className="font-medium mr-2" data-id="element-17693">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17694">
              <span className="font-medium mr-2" data-id="element-17695">Published:</span>
              January 2026
            </div>
          </div>

          <div className="bg-gray-50 border-l-4 border-blue-500 p-4 mb-3" data-id="element-17696">
            <p className="text-sm text-gray-700 leading-relaxed italic" data-id="element-17697">
              <strong data-id="element-17698">Editor's Note:</strong> This is Martha's story. Martha R.
              is one of the estimated 16 million Americans currently on GLP-1
              weight loss medication. She's 52, a mother of two, married for 26
              years. Like millions of Americans, she started GLP-1 medication
              hoping to finally win the battle with her weight. She lost 38
              pounds in five months. She also almost lost something else. What
              follows is her account, in her own words.
            </p>
          </div>

          {/* Martha's Image */}
          <div className="mb-6" data-id="element-17699"></div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv5;